"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var formik_1 = require("formik");
var FormItem_1 = __importDefault(require("../FormItem"));
var contexts_1 = require("../../contexts");
var RangePicker = antd_1.DatePicker.RangePicker;
var resolveFieldValue = function (date, valueFormat) {
    if (date) {
        return valueFormat ? date.format(valueFormat) : date.toISOString();
    }
    return undefined;
};
var resolveCalendarValue = function (values, startName, endName, valueFormat) {
    if (values) {
        var startDate = values[startName] && moment_1.default(values[startName], valueFormat);
        var endDate = values[endName] && moment_1.default(values[endName], valueFormat);
        return [startDate, endDate];
    }
    return [undefined, undefined];
};
var FormRangePicker = function (props) {
    var startName = props.startName, endName = props.endName, valueFormat = props.valueFormat, label = props.label, span = props.span, validate = props.validate, validateSchema = props.validateSchema, required = props.required, restProps = __rest(props, ["startName", "endName", "valueFormat", "label", "span", "validate", "validateSchema", "required"]);
    var formItemProps = { label: label, span: span, validate: validate, validateSchema: validateSchema, required: required, name: startName };
    var allowEdit = react_1.useContext(contexts_1.PermissionContext).allowEdit;
    return (react_1.default.createElement(FormItem_1.default, __assign({}, formItemProps),
        react_1.default.createElement(formik_1.Field, null, function (fieldProps) {
            var _a = fieldProps.form, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, values = _a.values;
            return (react_1.default.createElement(RangePicker, __assign({ style: { width: '100%' }, disabled: !allowEdit, value: resolveCalendarValue(values, startName, endName, valueFormat), onChange: function (date) {
                    setFieldValue(startName, resolveFieldValue(date[0], valueFormat));
                    setFieldValue(endName, resolveFieldValue(date[1], valueFormat));
                    setFieldTouched(startName, true);
                    setFieldTouched(endName, true);
                }, onPanelChange: function (date) {
                    setFieldValue(startName, resolveFieldValue(date && date[0], valueFormat));
                    setFieldValue(endName, resolveFieldValue(date && date[1], valueFormat));
                    setFieldTouched(startName, true);
                    setFieldTouched(endName, true);
                } }, restProps)));
        })));
};
exports.default = FormRangePicker;
